interface Props {
  eta: number | string;
}
export const WatchIcon = ({ eta }: Props) => {
  return (
    <svg width="41" height="49" viewBox="0 0 41 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.6334 20.5C31.9223 19.2037 29.2112 16.9073 27.5 15.611C29.2456 13.5961 30.9789 11.5668 32.7442 9.5686C33.9162 8.24123 35.1817 8.16245 36.5974 9.26541C36.9027 9.50414 38.208 10.7453 38.4961 11.0031C39.7222 12.1084 39.8404 13.3594 38.7669 14.6152C37.0804 16.5943 35.3471 18.54 33.6334 20.5Z"
        fill="#FFDDB9"
      />
      <path
        d="M18.5085 5.67329C19.7434 5.67329 20.9798 5.67188 22.2147 5.67188C22.2176 6.88285 22.2218 8.09382 22.2246 9.30479C20.9826 9.24516 19.742 9.19973 18.5 9.30337C18.5042 8.09382 18.5056 6.88427 18.5085 5.67329Z"
        fill="#112822"
      />
      <path
        d="M18.6798 6.5C17.7158 6.48889 16.7504 6.47963 15.7864 6.46482C14.8434 6.45001 14.5206 6.026 14.5081 4.77249C14.4997 3.86152 14.4941 2.9487 14.5109 2.03773C14.5318 0.993442 14.8601 0.51759 15.6299 0.513887C18.8782 0.495371 22.1264 0.495371 25.3746 0.513887C26.157 0.51759 26.4853 0.993442 26.4937 2.02106C26.5021 3.00609 26.5021 3.99298 26.4937 4.97801C26.4839 5.98897 26.1444 6.4389 25.3551 6.46112C24.3534 6.49074 23.3517 6.48704 22.3499 6.49815C21.1261 6.5 19.9036 6.5 18.6798 6.5Z"
        fill="#112822"
      />
      <path
        d="M40.5 28.5C40.5 39.5457 31.5457 48.5 20.5 48.5C9.4543 48.5 0.5 39.5457 0.5 28.5C0.5 17.4543 9.4543 8.5 20.5 8.5C31.5457 8.5 40.5 17.4543 40.5 28.5Z"
        fill="white"
      />
      <rect x="31.5" y="27.5" width="7" height="2" rx="1" fill="#FFDDB9" />
      <rect x="2.5" y="27.5" width="7" height="2" rx="1" fill="#FFDDB9" />
      <rect x="21.5" y="8.5" width="7" height="2" rx="1" transform="rotate(90 21.5 8.5)" fill="#FFDDB9" />
      <rect x="21.5" y="41.5" width="7" height="2" rx="1" transform="rotate(90 21.5 41.5)" fill="#FFDDB9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 45.5C29.8888 45.5 37.5 37.8888 37.5 28.5C37.5 19.1112 29.8888 11.5 20.5 11.5C11.1112 11.5 3.5 19.1112 3.5 28.5C3.5 37.8888 11.1112 45.5 20.5 45.5ZM20.5 48.5C31.5457 48.5 40.5 39.5457 40.5 28.5C40.5 17.4543 31.5457 8.5 20.5 8.5C9.4543 8.5 0.5 17.4543 0.5 28.5C0.5 39.5457 9.4543 48.5 20.5 48.5Z"
        fill="#FF8400"
      />
      <text x="20.5" y="35" textAnchor="middle" fill="black" fontWeight="Bold" fontSize={20}>
        {eta}
      </text>
    </svg>
  );
};
